module.exports = __webpack_public_path__ + "static/media/battery_5.119f324b.png";